import { UserRole } from '@interfaces/auth';

/**
 * O `userRoles` de uma requisição de relatório, a partir do papel escolhido no filtro.
 *
 * **`undefined` quando não há papel escolhido — o campo fica AUSENTE, e não vazio.**
 *
 * A primeira versão devolvia `[]` e a docstring afirmava que o campo continuava indo. Era falso, e a
 * revisão pegou: todo caminho de relatório passa pelo `parseFilters`, que descarta campo cujo
 * `toString()` é vazio — e `[].toString()` é `''`. O corpo do POST nunca tinha a chave. O código
 * dizia uma coisa e a rede fazia outra.
 *
 * Consertar o `parseFilters` seria pior: `botConfigIds: []` passaria a ser enviado, e lista vazia de
 * comunidade significa "sem recorte" do outro lado — o pedido viraria a base inteira. Então quem se
 * corrige é a afirmação.
 *
 * Ausente é aceito de propósito: os DTOs da `report-api` validam `userRoles` com
 * `@ValidateIf((filters) => filters.scopeByProduct === undefined)`, e a `platform-api` compõe o mapa
 * em toda requisição de relatório (api#277). Sem papel escolhido, o escopo por produto responde
 * sozinho — é isso que permite servir a comunidade alcançada por grant, que não tem papel de
 * comissão nenhum.
 *
 * Existe como função porque são dezessete pontos mandando o mesmo campo: dezessete ternárias
 * divergem, e divergir aqui manda papel onde não devia.
 */
export const userRolesDoPedido = (papel?: UserRole): UserRole[] | undefined =>
  papel ? [papel] : undefined;
